import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/submit/page.tsx");
